import privileges from '@ubeya/shared-web/privileges';

export const getDefaultPath = ({ isHost, privilegesWithModules }) => {
  let defaultModuleName = 'dashboard';

  if (isHost && !!privilegesWithModules[privileges.SCHEDULING]) {
    defaultModuleName = 'scheduling';
  }

  return `/:accountId/${defaultModuleName}`;
};
